import Menu from "./Menu";

//NECESARIO PARA MODIFICAR EL BODY
import $ from "jquery";
import { useEffect, useState } from "react";
import logo_dark from "../assets/logos/blanco.png";
//data-kt-aside-minimize="on"

const Aside = ({menuMobileState,setmenuMobileState}) => {
  const [menuAbierto, setmenuAbierto] = useState(true);
  const [estado, setestado] = useState(false);
  
  const handleToggle = () => {
    if (menuAbierto) {
      $("body").attr("data-kt-aside-minimize", "off");
      setmenuAbierto(false);
      localStorage.setItem("menuAbierto", "false");
    } else {
      $("body").attr("data-kt-aside-minimize", "on");
      setmenuAbierto(true);
      localStorage.setItem("menuAbierto", "true");
    }
  };

 
  useEffect(() => {
    const menuAbiertoStorage = localStorage.getItem("menuAbierto");
    if (menuAbiertoStorage === "true") {
      setmenuAbierto(true);
      handleToggle();
    }
    if (menuAbiertoStorage === "false") {
      setmenuAbierto(false);
      handleToggle();
    }
  }, []);
/*
  useEffect(() => {
    console.log(menuMobileState);
    if (!menuMobileState) {
      setestado(true);
    } else {
      setestado(false);
    }
  }, [menuMobileState])*/
  
  const cerrarMenuMobile = () => {
    setmenuMobileState(false);
  }

  //aside aside-dark aside-hoverable drawer drawer-start drawer-on
  //aside aside-dark aside-hoverable drawer drawer-start
  return (
    <div
      id="kt_aside"
      data-estado={menuMobileState}
      className={menuMobileState ? 'aside aside-dark aside-hoverable drawer-on drawer drawer-start' : 'aside aside-dark aside-hoverable'}
      data-kt-drawer="true"
      data-kt-drawer-name="aside"
      data-kt-drawer-activate="{default: true, lg: false}"
      data-kt-drawer-overlay="true"
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction="start"
      data-kt-drawer-toggle="#kt_aside_mobile_toggle"
    > 
      <div 
      
      className="col-md-12 text-right contenedor-icono">
      {menuMobileState ? 
      <i className="fas fa-arrow-left" onClick={cerrarMenuMobile}></i>
      : ''}
      </div>
      
      <div className="aside-logo flex-column-auto" id="kt_aside_logo">
        <a href="/home">
          <img alt="Logo" src={logo_dark} className="h-60px logo" />
        </a>
        <div
          onClick={handleToggle}
          id="kt_aside_toggle"
          className="btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle active"
          data-kt-toggle="true"
          data-kt-toggle-state="active"
          data-kt-toggle-target="body"
          data-kt-toggle-name="aside-minimize"
        >
          {menuAbierto ? (
            <i className="fas fa-arrow-right"></i>
          ) : (
            <i className="fas fa-arrow-left"></i>
          )}
        </div>
      </div>

      <Menu />
    </div>
  );
};

export default Aside;
